var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSomethingWrong = function SvgSomethingWrong(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    viewBox: "0 0 276 213"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 82868"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h276v213H0z",
    "data-name": "Rectangle 30783"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Something went wrong"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e1ecff",
    d: "M58.193 103.088c-2.858.046-5.118 4.334-.968 6.593 3.596 1.983 9.216-6.777.968-6.593",
    "data-name": "Path 48790"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e1ecff",
    d: "M62.803 120.099c-3.919 2.72-23.421 4.2-28.4 3-3-.692-4.795-3-4.288-5.394.323-1.475 1.429-2.951 3.6-4.241.184-.092.323-.185.507-.277 2.213-1.2-7.838.277-10.327-3.412a4.4 4.4 0 0 1-.83-2.351c-.184-3.043 3.32-6.086 12.079-7.008 11.111-1.153 18.9-.507 17.473 4.426-1.429 4.979-1.844 5.994 3.5 7.331 3.55.876 7.054 2.9 7.838 4.933.462 1.012.185 2.072-1.152 2.993",
    "data-name": "Path 48791"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cae0ff",
    d: "M38.922 111.894c-.737.922-3.135 1.291-5.21 1.568.185-.092.323-.185.507-.277 2.213-1.2-7.838.277-10.327-3.412a4.4 4.4 0 0 1-.83-2.351c.507.83 1.752 1.8 4.7 2.213 5.72.83 12.312.876 11.16 2.259",
    "data-name": "Path 48792"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cae0ff",
    d: "M62.805 120.101c-3.919 2.72-23.421 4.2-28.4 3-3-.692-4.795-3-4.288-5.394.922 1.06 3.5 3.043 10.1 3 8.806-.092 19.779-.461 22.361-1.982a3.13 3.13 0 0 0 1.429-1.614c.41 1.007.133 2.068-1.202 2.99",
    "data-name": "Path 48793"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e1ecff",
    d: "M218.911 118.075a5.2 5.2 0 0 1-1.936 2.582c-4.564 3.734-13.647 1.844-16.367 2.674-.784.231-.968.646-.784 1.153.507 1.291 3.5 3.089 6.132 3.827 4.61 1.291 6.962 3.412 7.838 5.487a4.7 4.7 0 0 1-3.735 6.634c-4.933.553-18.58-2.259-25.034-.553s-10.235 2.72-15.721-.323c-3.919-2.167-5.072-5.671-4.242-8.529a6.8 6.8 0 0 1 1.752-3c3-2.951 8.852-.922 9.359-2.443s-3.642-6.316-1.245-10.189 7.515-4.38 13.785-3.319 19.087-.138 23.974.645c3.78.648 6.962 2.723 6.224 5.354",
    "data-name": "Path 48794"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e1ecff",
    d: "M216.099 124.158c-3.6.046-5.256 2.766-2.443 5.164s7.653.277 7.515-1.752-2.675-3.458-5.072-3.412",
    "data-name": "Path 48795"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cae0ff",
    d: "M210.059 140.478c-4.933.553-18.58-2.259-25.034-.553s-10.235 2.72-15.721-.323c-3.919-2.167-5.072-5.671-4.242-8.529.277 1.66 1.521 3.965 5.855 5.487 7.469 2.628 12.4-1.2 18.995-1.2s13.6 4.2 20.424 2.628c3.043-.692 3.688-2.443 3.458-4.2a4.73 4.73 0 0 1-3.735 6.69",
    "data-name": "Path 48796"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cae0ff",
    d: "M218.912 118.072a5.2 5.2 0 0 1-1.936 2.582c-4.564 3.734-13.647 1.844-16.367 2.674-.784.231-.968.646-.784 1.153-.369-.092-.738-.23-1.06-.323-3-1.06-3.6-2.9-.461-3.965s8.76.138 15.4-.968a33.6 33.6 0 0 0 5.208-1.153",
    "data-name": "Path 48797"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fec272",
    d: "m138.414 81.604-7.745 94.88a.79.79 0 0 1-.645.738 1.018 1.018 0 0 1-1.153-1.061l7.515-94.882a.81.81 0 0 1 .83-.737h.23a.97.97 0 0 1 .968 1.062",
    "data-name": "Path 48798"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fea691",
    d: "M162.388 84.877a174 174 0 0 1-3.55 8.99 162 162 0 0 1-14.2 26.879 83.5 83.5 0 0 1-8.483 10.972 5 5 0 0 1-.553.553s-.784.277-2.213.737a92.7 92.7 0 0 1-14.108 3.181c-1.2.185-2.443.323-3.642.415a44.6 44.6 0 0 1-13.37-.645 23 23 0 0 1-4.656-1.568c-.046 0-.092-.046-.138-.046a129 129 0 0 1-9.774-10.051c-7.976-8.99-18.949-23.329-25.357-40.249-.784-2.028-1.429-4.1-2.029-6.224-7.192-25.541-1.429-57.445 33.241-67.957a78 78 0 0 1 11.987-2.582c1.014-.138 2.029-.277 3-.323a59 59 0 0 1 6.316-.277 49.7 49.7 0 0 1 16.828 3c29.548 10.788 40.383 48.685 30.701 75.195",
    "data-name": "Path 48799"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f9917d",
    d: "M158.838 93.867c-11.3 26.833-23.19 38.4-23.19 38.4s-.784.277-2.213.737a93 93 0 0 1-14.108 3.181c-1.2.185-2.444.323-3.642.415a44.6 44.6 0 0 1-13.37-.645 26.7 26.7 0 0 1-4.8-1.614s-24.158-21.392-35.131-50.3c-.784-2.028-1.429-4.1-2.028-6.224 9.082 8.114 26.648 19.179 55.371 19.871 21.949.467 35.227-1.608 43.111-3.821",
    "data-name": "Path 48800"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffd199",
    d: "M115.639 136.56a44.6 44.6 0 0 1-13.37-.646 190 190 0 0 1-19.133-44.352 169 169 0 0 1-3.781-16.321c-5.44-30.982 5.3-53.112 14.154-65.375a78 78 0 0 1 11.987-2.582c1.014-.138 2.028-.277 3-.323-3.827 5.532-12.632 21.9-10.558 53.388a227 227 0 0 0 5.9 36.422 388 388 0 0 0 11.801 39.789",
    "data-name": "Path 48801"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffd199",
    d: "M149.295 66.851a160 160 0 0 1-3.6 29.553 171 171 0 0 1-12.31 36.56 93 93 0 0 1-14.108 3.181 216 216 0 0 0 8.76-38.5 164 164 0 0 0 1.2-30.014 181.9 181.9 0 0 0-14.429-60.992 49.7 49.7 0 0 1 16.828 3c8.945 12.675 18.396 32.085 17.659 57.212",
    "data-name": "Path 48802"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fec272",
    d: "M115.634 136.562a44.6 44.6 0 0 1-13.37-.646 190 190 0 0 1-19.13-44.354 91.8 91.8 0 0 0 20.655 5.21 398 398 0 0 0 11.845 39.79",
    "data-name": "Path 48803"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fec272",
    d: "M145.698 96.403a171 171 0 0 1-12.31 36.56 93 93 0 0 1-14.108 3.181 216 216 0 0 0 8.76-38.5 158 158 0 0 0 17.658-1.241",
    "data-name": "Path 48804"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffd199",
    d: "M144.638 120.7a83.5 83.5 0 0 1-8.483 10.973 41.5 41.5 0 0 0-18.4-3.5 44.45 44.45 0 0 0-20.1 6.132c-.046 0-.092-.046-.138-.046a129 129 0 0 1-9.774-10.051c3.965-3.642 13.324-10.373 29.184-11.019 13.834-.511 22.916 4.099 27.711 7.511",
    "data-name": "Path 48805"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fec272",
    d: "M97.612 134.347a44.7 44.7 0 0 1 19.087-6.132 35.6 35.6 0 0 1 19.456 3.5s.092 2.49-19.087 4.933c-14.477 1.802-19.456-2.301-19.456-2.301",
    "data-name": "Path 48806"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc7059",
    d: "M157.824 50.345a24.9 24.9 0 0 0-.369 8.944 13.5 13.5 0 0 0 2.674 6.27 21.5 21.5 0 0 0-.092-7.331 30.1 30.1 0 0 0-2.213-7.883",
    "data-name": "Path 48807"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fec272",
    d: "m63.956 86.214 47.81 96.91a.92.92 0 0 1-.23 1.107l-.138.138a.9.9 0 0 1-1.429-.277L62.016 87.228a.894.894 0 0 1 .369-1.2l.323-.185a.872.872 0 0 1 1.248.371",
    "data-name": "Path 48808"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fec272",
    d: "m92.909 83.859 26.233 96.311a1.02 1.02 0 0 1-.415 1.061l-.138.138c-.553.415-1.245.277-1.383-.323L90.788 84.781a1.08 1.08 0 0 1 .6-1.2l.323-.185a.823.823 0 0 1 1.198.463",
    "data-name": "Path 48809"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fec272",
    d: "m162.572 80.405-31.12 98.57a.88.88 0 0 0 .415 1.06l.553.277a.887.887 0 0 0 1.291-.507l31.351-98.524a.915.915 0 0 0-.507-1.106l-.738-.323a.954.954 0 0 0-1.245.553",
    "data-name": "Path 48810"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fec272",
    d: "M93.832 152.235a1.085 1.085 0 0 1 1.152-1.337 130.4 130.4 0 0 0 26.51-1.383 160.6 160.6 0 0 0 21.853-5.071 1.164 1.164 0 0 1 1.521 1.06 1.14 1.14 0 0 1-.784 1.06 175 175 0 0 1-22.729 5.3 148.7 148.7 0 0 1-26.464 1.337 1.085 1.085 0 0 1-1.06-.876Z",
    "data-name": "Path 48811"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fec272",
    d: "m63.264 87.874 100.649-5.855a2.153 2.153 0 0 0 2.029-2.075v-.185a2.117 2.117 0 0 0-2.259-2.213L63.034 83.629a2.174 2.174 0 0 0-1.983 2.628 2.11 2.11 0 0 0 2.213 1.617",
    "data-name": "Path 48812"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffd199",
    d: "M137.077 162.747s6.916 1.752 10.327 3.6c3.412 1.89 1.153 6.916-1.936 6.362-2.213-.415-5.44-5.487-6.593-7.054a18 18 0 0 1-1.798-2.908",
    "data-name": "Path 48813"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f46cb4",
    d: "m149.063 193.545-26.418 10.235-3.781 1.475a9.58 9.58 0 0 1-13.047-8.3l-1.66-22.821a3.73 3.73 0 0 1 2.674-3.827l7.1-2.121 19.917-5.948a3.7 3.7 0 0 1 4.288 1.752l.138.277 13.093 22.96c0 .046.046.092.046.138a4.45 4.45 0 0 1-2.35 6.18",
    "data-name": "Path 48814"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff97c9",
    d: "m122.647 203.779-3.78 1.475a9.58 9.58 0 0 1-13.047-8.3l-1.475-20.378-.184-2.444v-.369a3.7 3.7 0 0 1 2.674-3.458l7.1-2.121c.092.692.231 1.429.369 2.213.184 1.061.369 2.213.553 3.412 1.152 7.008 2.674 16.136 3.6 22.084a14.7 14.7 0 0 0 1.567 4.979 6.83 6.83 0 0 0 2.623 2.907",
    "data-name": "Path 48815"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f46cb4",
    d: "M114.808 173.858a7.61 7.61 0 0 1-5.625 3.873 6.85 6.85 0 0 1-4.887-1.107l-.185-2.443v-.369a3.7 3.7 0 0 1 2.674-3.458l7.1-2.121c.092.692.231 1.429.369 2.213.139 1.014.37 2.167.554 3.412",
    "data-name": "Path 48816"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef54ac",
    d: "M130.068 174.826a22.37 22.37 0 0 1-15.26-1.014l-.922-5.671 19.917-5.947a3.7 3.7 0 0 1 4.288 1.752l.138.277.092.507c.046.046.507 7.698-8.253 10.096",
    "data-name": "Path 48817"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1c3177",
    d: "m113.886 168.188.369 2.121s6.547 5.763 15.214 3.043c8.714-2.674 7.377-10.7 7.377-10.7a4.8 4.8 0 0 0-1.89-.507 13 13 0 0 0-2.766.6Z",
    "data-name": "Path 48818"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1c3177",
    d: "M114.255 170.4c-.185.738-1.107 4.334-4.38 5.44-3.227 1.106-5.348-1.521-5.763-2.075a3.7 3.7 0 0 1 2.674-3.458l7.1-2.121c.093.693.231 1.43.369 2.214",
    "data-name": "Path 48819"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef54ac",
    d: "m149.063 193.544-26.418 10.235-3.781 1.475a9.65 9.65 0 0 1-11.157-3.181 42.1 42.1 0 0 0 12.955-1.337 173 173 0 0 0 24.9-9.59 35 35 0 0 0 5.9-3.781 4.5 4.5 0 0 1-2.399 6.179",
    "data-name": "Path 48820"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f46cb4",
    d: "m122.646 203.78-3.781 1.475a9.65 9.65 0 0 1-11.157-3.181 39.8 39.8 0 0 0 12.31-1.2 6.83 6.83 0 0 0 2.628 2.906",
    "data-name": "Path 48821"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fec272",
    d: "M118.635 142.323c-4.426.553-7.745-3.366-5.025-6.547a14.8 14.8 0 0 0 3.227-5.993s5.44 3.043 6.132 6.408c.507 2.582.139 5.579-4.334 6.132",
    "data-name": "Path 48822"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc7059",
    d: "M118.312 141.17c-1.752.092-3.6-.784-3.273-2.858s2.167-2.858 2.536-4.241a2.87 2.87 0 0 0 0-2.029s3.227 2.305 3.6 5.348c.319 3.042-1.664 3.734-2.863 3.78",
    "data-name": "Path 48823"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1c3177",
    d: "m111.904 144.813-.231-2.121a1.164 1.164 0 0 1 .876-1.245 39 39 0 0 1 5.9-.784 46 46 0 0 1 5.21-.138 1.14 1.14 0 0 1 1.107 1.014l.277 2.075a1.25 1.25 0 0 1-.738 1.245 21.2 21.2 0 0 1-6.086 1.061 38 38 0 0 1-5.3 0 1.275 1.275 0 0 1-1.015-1.107",
    "data-name": "Path 48824"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1c3177",
    d: "M151.646 165.329s9.636-9.036 13.047-8.714c2.029.184-.185 2.858-3.135 4.61s-9.912 4.104-9.912 4.104",
    "data-name": "Path 48825"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1c3177",
    d: "M153.812 168.507c-1.2-.185-.507-1.936.876-1.936s48.132.553 47.072.968c-1.014.468-46.703 1.11-47.948.968",
    "data-name": "Path 48826"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1c3177",
    d: "m171.056 66.756 6.362 1.291a1.186 1.186 0 0 1 .922 1.429c-.138.645-.83.692-1.475.553-.138-.046-.231-.092-.369-.138l-5.809-2.305a.453.453 0 0 1-.185-.6.56.56 0 0 1 .554-.23",
    "data-name": "Path 48827"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1c3177",
    d: "m169.857 71 5.3 4.656a1.078 1.078 0 1 1-1.429 1.614l-.138-.138-4.334-5.578a.437.437 0 0 1 .092-.6.5.5 0 0 1 .509.046",
    "data-name": "Path 48828"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1c3177",
    d: "m163.633 37.483 1.383-5.44a1.05 1.05 0 0 1 1.982.692.16.16 0 0 1-.046.092l-2.4 5.025a.47.47 0 0 1-.645.231.53.53 0 0 1-.274-.6",
    "data-name": "Path 48829"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1c3177",
    d: "m165.987 41.816 8.99-5.3a1.036 1.036 0 1 1 1.106 1.752.17.17 0 0 1-.138.046l-9.589 4.241a.457.457 0 0 1-.6-.23.64.64 0 0 1 .231-.509",
    "data-name": "Path 48830"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1c3177",
    d: "m167.643 47.671 6.869-1.752a1.016 1.016 0 0 1 1.245.6.987.987 0 0 1-.738 1.152c-.046 0-.138.046-.184.046l-7.054.6c-.185 0-.369-.092-.369-.277a.285.285 0 0 1 .231-.369",
    "data-name": "Path 48831"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e1ecff",
    d: "M194.983 57.354c-13.831 4.749-33.471.968-33.471.968-1.475-.23-1.8-.692-1.568-1.2.369-.738 2.075-1.614 3.412-1.936 3.734-.876 9.405-1.383 13.877-4.1 4.518-2.72 0-7.054 2.766-9.866s6.823.323 8.9-2.628c1.936-2.766-6.593-6.454-5.532-9.728s4.334-3.273 4.518-6.916c.138-3.043 7.792-9.912 13.785-5.671a11 11 0 0 1 3.273 3.919c6.038 11.065 3.871 32.365-9.96 37.158",
    "data-name": "Path 48832"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cae0ff",
    d: "M194.983 57.354c-13.831 4.749-33.471.968-33.471.968-1.475-.23-1.8-.692-1.568-1.2 3.919.046 15.491.138 20.563-1.337 6.132-1.8 5.532-5.394 4.334-5.994a2.87 2.87 0 0 0-2.167-.23s.461-2.167 4.795-1.337c4.242.83 3.412 4.288 3.366 4.426.23-.138 8.207-4.38 8.99-8.068.83-3.734-4.426-7.469-1.936-10.1 2.536-2.628 4.2-.968 4.933.369a8 8 0 0 1 .83 1.8 35.8 35.8 0 0 0 .461-10.465 28.2 28.2 0 0 0-2.49-9.913 11 11 0 0 1 3.273 3.919c6.085 11.067 3.918 32.367-9.913 37.162",
    "data-name": "Path 48833"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e1ecff",
    d: "M252.66 54.634c.507 5.256-36.791 4.1-58.321 3.781s-29.507-.369-29.184-2.029c.046-.23.415-.507 1.014-.784 3.5-1.568 15.353-3.6 22.545-6.685 8.437-3.6 9.728-17.1 23.052-16.92 7.192.092 5.578 8.252 6.132 10 .553 1.706 5.3-8.76 12.356-6.547s-.645 12.632.738 13.508c1.337.83 19.41.461 21.484 5.025a2.6 2.6 0 0 1 .184.651",
    "data-name": "Path 48834"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cae0ff",
    d: "M252.66 54.633c.507 5.256-36.791 4.1-58.321 3.781s-29.507-.369-29.184-2.029c.046-.23.415-.507 1.014-.784 6.27-.185 30.613-1.06 36.975-2.121 7.33-1.2 4.334-5.993 4.334-5.993s3.5-.369 4.426 2.305c.968 2.628-1.337 5.532-1.337 5.532s28.031.83 36.653.23c2.674-.184 4.288-.784 5.21-1.567a1.55 1.55 0 0 1 .23.646",
    "data-name": "Path 48835"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e1ecff",
    d: "M215.177 65.191a9 9 0 0 1-.738 2.121c-3.181 6.916-18.073-.876-18.4-1.06.23.185 5.394 5.025-.23 7.561-5.717 2.582-7.745-2.075-16.044-7.7-8.345-5.671-19.41-6.547-19.41-6.547a2.14 2.14 0 0 1-1.89-.876c-.646-1.061.323-2.72 4.1-2.49 2.075.138 36.975-.646 42.738.184 5.216.738 10.98 3.274 9.874 8.807",
    "data-name": "Path 48836"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cae0ff",
    d: "M215.177 65.191a9 9 0 0 1-.738 2.121c-3.181 6.916-18.073-.876-18.4-1.06.231.185 5.394 5.025-.23 7.561-5.717 2.582-7.745-2.075-16.044-7.7-8.345-5.671-19.41-6.547-19.41-6.547a2.14 2.14 0 0 1-1.89-.876 36.1 36.1 0 0 1 18.857 4.149c10.189 5.348 12.725 9.221 15.86 7.146 3.043-2.028-.692-6.593-.876-6.823a73.6 73.6 0 0 0 10 2.72c6.047 1.337 10.519.83 12.871-.691",
    "data-name": "Path 48837"
  })))));
};
export default SvgSomethingWrong;